<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/news/newslist">资讯</shBreadItem>
      <shBreadItem v-if="newsdesc.length"
        ><div class="bread">{{ newsdesc[0]?.neName }}</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="news-desc">
    <div class="detail">
      <NewsDesc :newsdesc="newsdesc" />
    </div>
    <div class="desc-right">
      <div class="news-recom"></div>
      <VideoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { findVideoRecommand, findVideoRandom } from "@/api/video";
import { findNewsDetail } from "@/api/news";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import VideoRecommend from "@/components/video-recommend.vue";
import NewsDesc from "./components/news-desc.vue";
export default {
  components: { VideoRecommend, NewsDesc },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const newsdesc = ref([]);
    const VideoReCommend = ref([]);
    findNewsDetail(route.query.id)
      .then((data) => {
        //console.log(data);
        newsdesc.value = data;
      })
      .catch((error) => {
        console.log(error);
      });

    if (route.query.clID) {
      findVideoRecommand(route.query.clID.split(","))
        .then((data) => {
          //console.log(data);
          VideoReCommend.value = data.map((item) => {
            return {
              chID: item.chID,
              maID: item.maID,
              coID: item.coID,
              clID: item.clID,
              leName: item.leName,
              leImg: "/web/" + item.leImg,
              coverImg: "/web/" + item.coverImg,
              grade: item.grade.find((ele) => ele._id == item.gradeID),
              id: item._id,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      findVideoRandom(10)
        .then((data) => {
          VideoReCommend.value = data.map((item) => {
            return {
              chID: item.chID,
              maID: item.maID,
              coID: item.coID,
              clID: item.clID,
              leName: item.leName,
              leImg: "/web/" + item.leImg,
              coverImg: "/web/" + item.coverImg,
              grade: item.grade.find((ele) => ele._id == item.gradeID),
              id: item._id,
            };
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    //这里有两个clID的时候用，分割使其变成数组

    return { newsdesc, VideoReCommend };
  },
};
</script>

<style lang="less" scoped>
.fade {
  &-leave {
    &-active {
      position: absolute;
      width: 100%;
      transition: opacity 0.5s 0.2s;
      z-index: 1;
    }
    &-to {
      opacity: 0;
    }
  }
}
.news-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.news-desc {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  min-height: 700px;
  margin: 0 auto;
  .detail {
    width: 850px;
    background: #fff;
  }
  .desc-right {
    width: 350px;
    //background: #999;
  }
}
</style>
